import { AppBar } from '@mui/material';

import AppName from '../parts/AppName';
import AppVersion from '../parts/AppVersion';
import LoginUserInfo from '../parts/LoginUserInfo';
import PopUpMenu from '../parts/PopUpMenu';
import { MemoSideBarOpenButton } from '../parts/SideBarButton';
import LogoutButton from '../parts/LogoutButton';

import { appBar, width } from '../../const/componentSize';
import { UserInfoType } from '../../type/UserInfoType';
import { StyledToolbar } from '../styled/ToolbarStyled';

type HeaderPropsType = {
	isLogin: boolean;
	handleDrawerOpen: () => void;
	userInfo: UserInfoType;
	setUserInfo: React.Dispatch<React.SetStateAction<UserInfoType>>;
};

/**
 * ヘッダー
 */
const Header = (props: HeaderPropsType) => {
	const { isLogin, handleDrawerOpen, userInfo, setUserInfo } = props;

	return (
		<AppBar sx={{ height: appBar.height, width: width, position: 'absolute', top: 0, left: 0 }}>
			<StyledToolbar>
				<MemoSideBarOpenButton isLogin={isLogin} handleDrawerOpen={handleDrawerOpen} />
				<AppName />
				<AppVersion />
				<LoginUserInfo userInfo={userInfo} />
				<LogoutButton setUserInfo={setUserInfo} />
				<PopUpMenu />
			</StyledToolbar>
		</AppBar>
	);
};

export default Header;
